import { Field } from '../../settings/types/field';

export const getEmailField = (fields: Field[]) =>
  fields?.find((field) => field?.label?.toLowerCase() === 'email');
